module.exports = __webpack_public_path__ + "img/greenEnergy.6f150e3e.png";